import React from "react";
import PropTypes from "prop-types";

const FormCheck = (props) => {
  const {
    name,
    checked,
    onChange,
    bottomTitle,
    checkBoxClassName,
    containerClassName } = props;

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      onChange({ target: { name, checked: checked ? false : true } });
    }
  };
  return (
    <div className={`${containerClassName}`}>
      <div className={ `form-check ${checkBoxClassName}`}>
        <input
          name={name}
          className="form-check-input"
          type="checkbox"
          id="checkbox3"
          checked={checked}
          onChange={onChange}
          onKeyDown={handleKeyDown}
        />
        <label className="form-check-label">
         {bottomTitle}
        </label>
      </div>
    </div>
  );
};
FormCheck.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  bottomTitle: PropTypes.string,
  checkBoxClassName: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default FormCheck;



